import * as React from 'react';
export const fcbSvg = React.forwardRef(function fcbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0066B6',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M21.1 22.49V9.5h3.2c1.76 0 3.18 1.3 3.18 2.9 0 1.35-1 2.48-2.35 2.81 1.46.38 2.55 1.84 2.55 3.59 0 2.03-1.47 3.68-3.29 3.68l-.2-.01h-3.08zm1.84-5.81H21.3v3.48h1.65c.9 0 1.64-.78 1.64-1.74s-.74-1.74-1.65-1.74zm-.19-4.84H21.3v2.7h1.45c.8 0 1.45-.6 1.45-1.35 0-.75-.65-1.35-1.45-1.35zm-15 5.42v5.23H4.31V9.5h8.65v2.52H7.74v2.9h2.42v2.33H7.74zm9 .47a3.02 3.02 0 1 1 0-3.46h3.74a6.48 6.48 0 0 0-6.53-4.75h7.15v12.97h-7.15v-.01h.3a6.48 6.48 0 0 0 6.23-4.75h-3.74z',
      }),
    ),
  );
});
fcbSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var fcb = {
  category: 'brand',
  colorable: false,
  name: 'fcb',
  svg: fcbSvg,
};
